import { api } from "./configs/axiosConfigs"

export const UbigeoAPI = {

    getCountries: async (data:any) => {
        const response = await api.get(
            '/ubigeo/listCountries', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    getDepartments: async (data:any) => {
        const response = await api.get(
            '/ubigeo/listDepartments', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    getProvinces: async (data:any) => {
        const response = await api.get(
            '/ubigeo/listProvinces', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    getDistricts: async (data:any) => {
        const response = await api.get(
            '/ubigeo/listDistricts', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}